/**
 * useAudit — audit data hooks using TanStack Query
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import { runAuditApi, computeAuditResult, getAuditHistoryApi } from '../api/auditApi'
import { useUIStore } from '../store/uiStore'
import { QUERY_KEYS } from '../config/constants'

/**
 * Mutation hook for running a single audit comparison
 */
export function useRunAudit() {
  const addToast = useUIStore((s) => s.addToast)

  return useMutation({
    mutationFn: ({ policy}) => runAuditApi({ policy}),
    onSuccess: (data) => {
      const result = computeAuditResult(data)
      if (result.computed.status === 'MATCH') {
        addToast({ type: 'success', title: 'Audit complete', message: 'Premiums match — no discrepancy found.' })
      } else {
        addToast({ type: 'warning', title: 'Mismatch detected', message: `Difference of ${result.computed.difference.toFixed(2)}` })
      }
    },
    onError: (err) => {
      addToast({ type: 'error', title: 'Audit failed', message: err.error || 'An unexpected error occurred' })
    },
  })
}

/**
 * Query hook for audit history list
 */
export function useAuditHistory(params = {}) {
  return useQuery({
    queryKey: [QUERY_KEYS.AUDIT_HISTORY, params],
    queryFn:  () => getAuditHistoryApi(params),
    staleTime: 60_000,
  })
}
